(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/prescript.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.ReactPayfooter = svs.tur.ReactPayfooter || {};
svs.tur.ReactPayfooter.utils = svs.tur.ReactPayfooter.utils || {};
const {
  CurrencyFromJupiterString: currencyFromJupiterString,
  Currency: formatCurrency
} = svs.utils.format;
const replaceBalanceRegexp = /\d([\d,]|\s(?!\D))*/;
function animateNumbers(_ref) {
  let {
    elements,
    element,
    from,
    to
  } = _ref;
  if (svs.core.detect.browser.ie()) {
    return to;
  }
  const fromParsed = currencyFromJupiterString(from);
  const toParsed = currencyFromJupiterString(to);
  const animateDecimals = fromParsed % 1 !== 0 || toParsed % 1 !== 0;
  if (!elements && !element && (isNaN(fromParsed) || isNaN(toParsed))) {
    return;
  }
  const gsapSumCounter = {
    sum: fromParsed
  };
  if (element) {
    elements = [element];
  }
  gsap.to(gsapSumCounter, 0.3, {
    sum: toParsed,
    onUpdate: () => {
      if (element) {
        elements = [element];
      }
      for (let i = 0; i < elements.length; i++) {
        const s = elements[i];
        const newNumber = animateDecimals ? gsapSumCounter.sum : Math.ceil(gsapSumCounter.sum);
        s.innerText = s.innerText.replace(replaceBalanceRegexp, formatCurrency(newNumber));
      }
    }
  });
}
function animateButtonPlop(_ref2) {
  let {
    element
  } = _ref2;
  if (!element) {
    return;
  }
  gsap.fromTo(element, {
    scaleY: 1.2,
    scaleX: 1.02
  }, {
    duration: 0.2,
    scale: 1,
    clearProps: 'all'
  });
}
svs.tur.ReactPayfooter.utils.animateNumbers = animateNumbers;
svs.tur.ReactPayfooter.utils.animateButtonPlop = animateButtonPlop;

 })(window);